import * as spaceController from './spaceController.js';
import * as taskController from './taskController.js';
import * as appView from '../views/appView.js';

spaceController.initSpaces();
taskController.initTasks();
